import { createContext, useContext, useState, ReactNode } from 'react';

type ErrorTag = 'warning' | 'success' | 'error';

interface ErrorState {
  open: boolean;
  messages: string[];
  tag: ErrorTag;
}

interface ErrorContextType {
  error: ErrorState;
  showError: (messages: string[] | string, tag?: ErrorTag) => void;
  clearError: () => void;
}

const GlobalErrorContext = createContext<ErrorContextType | null>(null);

export const GlobalErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<ErrorState>({
    open: false,
    messages: [],
    tag: 'error',
  });

  // const showError = (messages: string[] | string, tag: ErrorTag = 'error') => {
  const showError = (messages: unknown, tag: ErrorTag = 'error') => {
    let finalMessages: string[] = [];
    // if(typeof messages  === 'object'){
    //   setError({
    //     open: true,
    //     messages: Object.values(messages).flat(),
    //     tag,
    //   });
    // }
    // if(typeof messages  === 'string'){
    //   setError({
    //     open: true,
    //     messages: [messages],
    //     tag,
    //   });
    // }

    if (typeof messages === 'string') {
      // 處理字串
      finalMessages = [messages];
    } else if (Array.isArray(messages)) {
      // 處理陣列
      finalMessages = messages.map(msg => String(msg));
    } else if (messages instanceof Error) {
      // 處理標準 Error 物件
      finalMessages = [messages.message];
    } else if (typeof messages === 'object' && messages !== null) {
      // 處理物件 (例如：{ email: '格式錯誤', password: '太短' })
      finalMessages = Object.values(messages).flat().map(msg => String(msg));
    } else {
      // 備用方案
      finalMessages = ['發生未知錯誤'];
    }

    setError({
      open: true,
      messages: finalMessages,
      tag,
    });
  };

  const clearError = () => {
    setError(prev => ({ ...prev, open: false }));
  };

  return (
    <GlobalErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </GlobalErrorContext.Provider>
  );
};

export const useGlobalError = () => {
  const ctx = useContext(GlobalErrorContext);
  if (!ctx) {
    throw new Error('useGlobalError must be used inside GlobalErrorProvider');
  }
  return ctx;
};